import { render, staticRenderFns } from "./SheetTeacherItemRegister.vue?vue&type=template&id=54d381d8&scoped=true"
import script from "./SheetTeacherItemRegister.vue?vue&type=script&lang=js"
export * from "./SheetTeacherItemRegister.vue?vue&type=script&lang=js"
import style0 from "./SheetTeacherItemRegister.vue?vue&type=style&index=0&id=54d381d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d381d8",
  null
  
)

export default component.exports